import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import { RiskAssessmentResultControlType as Risk_Assessment_Result_Control_Type_Enum } from '@risksmart-app/domain/src/types/consts/risk-assessment-result-control-type';
import type { useGetInternalAuditResultsByParentId } from 'src/hooks/queries/internal-audit/useGetInternalAuditResultsByParentId';

import type { InternalAuditResultFields } from './types';

type GetInternalAuditResultsByParentIdData = NonNullable<
  ReturnType<typeof useGetInternalAuditResultsByParentId>['data']
>;

export const getInternalAuditResultTableFields = (
  data: GetInternalAuditResultsByParentIdData | undefined,
  assessmentId: string
): InternalAuditResultFields[] | undefined => {
  return [
    ...(data?.document_internal_audit_result.map((a) => ({
      ...a,
      ParentId: assessmentId,
      ResultType: Parent_Type_Enum.DocumentInternalAuditResult,
    })) || []),
    ...(data?.obligation_internal_audit_result.map((a) => ({
      ...a,
      ParentId: assessmentId,
      ResultType: Parent_Type_Enum.ObligationInternalAuditResult,
    })) || []),
    ...(data?.risk_controlled_internal_audit_result.map((a) => ({
      ...a,
      ParentId: assessmentId,
      ResultType: Parent_Type_Enum.RiskControlledInternalAuditResult,
      ControlType: Risk_Assessment_Result_Control_Type_Enum.Controlled,
    })) || []),
    ...(data?.risk_uncontrolled_internal_audit_result.map((a) => ({
      ...a,
      ParentId: assessmentId,
      ResultType: Parent_Type_Enum.RiskUncontrolledInternalAuditResult,
      ControlType: Risk_Assessment_Result_Control_Type_Enum.Uncontrolled,
    })) || []),
    ...(data?.control_test_internal_audit_result.map((a) => ({
      Id: a.Id,
      ParentId: assessmentId,
      Impact: 0,
      Rating: 0,
      OverallEffectiveness: a.OverallEffectiveness,
      ControlType: Risk_Assessment_Result_Control_Type_Enum.Controlled,
      TestDate: a.TestDate,
      parents: [],
      parent: a.parent!,
      // COI-974: `files` and `ancestorContributors` are no longer selected on
      // this read — the rating register has no column for either. This branch
      // used to carry `files: a.files` and a hardcoded `ancestorContributors:
      // []`, which was itself the clearest signal the field was unused.
      ResultType: Parent_Type_Enum.ControlTestInternalAuditResult,
    })) || []),
  ];
};
